export interface DisabledProps {
	/**
	 * Whether to disable all the descendant fields.
	 *
	 * @default true
	 */
	isDisabled?: boolean;

	/**
	 * The children elements.
	 */
	children: React.ReactNode;
}
